import React from 'react';
import PageLayout from '../../components/PageLayout';
import PageHero from '../../components/PageHero';
import PartnershipsCarousel from '../../components/PartnershipsCarousel';
import IfysEnquiryForm from '../../components/IfysEnquiryForm';

const BREADCRUMBS = [
  { label: 'Home', to: '/' },
  { label: 'Partnerships', to: '/partnerships/partner-with-us' },
  { label: 'Partner with Us' },
];

const PartnerWithUsPage = () => {
  return (
    <PageLayout activeLink="partnerships">
      <PageHero
        title="Partner with Us"
        backgroundImage="/images/service-headers/partnerships%201.jpg"
        breadcrumbs={BREADCRUMBS}
        variant="split"
      />

      <section className="bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 md:py-20">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-ifys-blue mb-6 tracking-tight text-center">
            Partnerships
          </h2>
          <div className="space-y-4 text-gray-700 text-sm sm:text-base leading-relaxed max-w-2xl mx-auto text-center">
            <p>
              In creating an accessible service, IFYS recognises that it is crucial to be involved in partnerships with
              external organisations to better assist children, young people and families remain connected to their
              community of choice.
            </p>
            <p className="font-semibold text-ifys-blue">
              IFYS is proudly supported by many businesses and organisations. If you would like to become a partner of
              IFYS, please complete the below form.
            </p>
          </div>
        </div>
      </section>

      <PartnershipsCarousel />

      <section className="relative bg-ifys-light-gray overflow-hidden border-t border-gray-200">
        <img
          src="/images/image.png"
          alt=""
          aria-hidden
          loading="lazy"
          className="hidden lg:block absolute -top-36 -right-36 w-80 h-80 object-cover rounded-full pointer-events-none"
        />
        <img
          src="/images/image.png"
          alt=""
          aria-hidden
          loading="lazy"
          className="hidden lg:block absolute -bottom-48 -left-48 w-96 h-96 object-cover rounded-full pointer-events-none"
        />

        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 md:py-20 relative z-10">
          <div className="max-w-4xl mx-auto bg-white rounded-2xl border border-gray-200 shadow-sm p-6 sm:p-8 md:p-10">
            <div className="mb-6 sm:mb-8 text-center">
              <h2 className="text-2xl sm:text-3xl font-bold text-ifys-blue tracking-tight">
                Become a partner
              </h2>
              <p className="mt-2 text-sm sm:text-base text-gray-600">
                Tell us about your organisation and we&rsquo;ll be in touch.
              </p>
            </div>
            <IfysEnquiryForm formId="partnerships" />
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default PartnerWithUsPage;
